const sanitizeHeading = (heading: string | string[] | null): null | number => {
  if (!heading) return null;
  if (typeof heading === "string") {
    const headingToParse = heading.split("-").pop() as string;
    return parseInt(headingToParse, 10) || null;
  }
  return parseInt(heading.shift() as string, 10) || null;
};

// South American Companies:
const southCentralAmericanCountryCodes: string[] = [
  "AR",
  "AW",
  "BZ",
  "BO",
  "BR",
  "CL",
  "CO",
  "CR",
  "CU",
  "DO",
  "EC",
  "SV",
  "FK",
  "GF",
  "GT",
  "GY",
  "HT",
  "HN",
  "MX",
  "AN",
  "NI",
  "PA",
  "PY",
  "PE",
  "GS",
  "SR",
  "TT",
  "UY",
  "VE",
];

const companyCountryLimitations = {
  "1242153": ["US", "CA", ...southCentralAmericanCountryCodes], // https://www.thomasnet.com/company/thermal-fluid-systems-1242153/profile
  "10005131": ["US", "CA"], // https://www.thomasnet.com/company/biolab-inc-10005131/profile
  "1308758": ["US", "CA"], // https://www.thomasnet.com/company/alpha-packaging-inc-1308758/profile
  "30978189": ["US", "CA", ...southCentralAmericanCountryCodes], // https://www.thomasnet.com/company/biocorp-nutrition-labs-30978189/profile
};

export { sanitizeHeading, companyCountryLimitations };
